exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".single-project-ref-data-usage-content {\n  min-height: 300px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  max-height: calc(100vh - 220px);\n  overflow: auto;\n}\n.single-project-ref-data-usage-content .spin {\n  text-align: center;\n}\n.single-project-ref-data-usage-content .empty {\n  width: 100%;\n}\n.single-project-ref-data-usage-content .ant-collapse {\n  width: 100%;\n  align-self: flex-start;\n}\n.single-project-ref-data-usage-content .ant-collapse .ant-collapse-extra {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n", ""]);

// exports
